<template>
    <oss-dialog v-model="dialog" :title="title" width="800px" @close="emitCloseDialog">
        <h4 v-if="selected">Compte comptable actuel : {{ selected }}</h4>
        <v-list
            two-line
            subheader
            style="background-color: transaparent; height: 30vh; overflow: scroll"
        >
            <v-list-item
                v-for="item in accountableAccounts"
                :key="item.name"
                :class="getItemClass(item.name)"
                @click="selectItem(item)"
            >
                <template #prepend v-if="item.subAccountableAccountOf">
                    <v-icon>$subdirectory_arrow_right</v-icon>
                </template>
                <v-list-item-title style="text-overflow: ellipsis; max-width: 600px">
                    {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ item.description }}
                </v-list-item-subtitle>

                <template #append>
                    <v-btn icon size="small">
                        <v-icon :color="isSelected(item) ? 'secondary' : 'primary'" size="small">{{
                            isSelected(item) ? "$oss-circle-check" : "$oss-circle-uncheck"
                        }}</v-icon>
                    </v-btn>
                </template>
            </v-list-item>
        </v-list>
        <template v-slot:actions>
            <v-row no-gutters>
                <v-col cols="6" v-if="showRemove">
                    <v-btn
                        class="rounded-lg gradient"
                        rounded
                        block
                        elevation="0"
                        @click="remove()"
                        size="x-large"
                        >Retirer</v-btn
                    >
                </v-col>
                <v-col :cols="showRemove ? 6 : 12">
                    <v-btn
                        class="rounded-lg gradient"
                        rounded
                        block
                        elevation="0"
                        :disabled="validDisabled"
                        @click="setItem()"
                        size="x-large"
                        >Valider</v-btn
                    >
                </v-col>
            </v-row>
        </template>
    </oss-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { filterAccountableAccounts } from "../../../../backend/src/common/accountableAccount/accountableAccountServices";
import { useStore } from "vuex";

const dialog = defineModel<boolean>({
    default: false,
});

const props = defineProps<{
    title?: string;
    accountableAccountNames?: any[];
    selected?: string;
    companyId?: string;
}>();

const emits = defineEmits<{
    close: [];
    select: [string];
}>();

const store = useStore();

const internalSelected = ref(props.selected);
const accountableAccountTable = store.state.accountableAccountTable;
debugger;

const inSelected = computed<string>({
    get: () => internalSelected.value || props.selected,
    set: (value: string) => {
        internalSelected.value = value;
    },
});

const selectItem = (item) => (inSelected.value = item.name);

const emitCloseDialog = () => emits("close");

const getItemClass = (itemName) => {
    let itemClass = "oss-list-item mb-2";
    if (itemName === inSelected.value) {
        itemClass += " oss-list-item-selected";
    }
    return itemClass;
};

const accountableAccounts = computed(() =>
    filterAccountableAccounts(accountableAccountTable.value, props.accountableAccountNames),
);

const showRemove = computed<boolean>(() => {
    if (!props.selected) return false;
    return props.accountableAccountNames.find((aan) => aan === props.selected);
});

const validDisabled = computed<boolean>(() => {
    if (!inSelected.value) return true;
    if (inSelected.value === props.selected) return true;
    return false;
});

const isSelected = (item) => {
    if (!inSelected.value) {
        return false;
    }
    return item.name === inSelected.value;
};

const setItem = () => {
    emits("select", inSelected.value);
    emitCloseDialog();
    inSelected.value = "";
    dialog.value = true;
};

const remove = () => {
    emits("select", "");
    dialog.value = true;
    emitCloseDialog();
};
</script>
